import { render, staticRenderFns } from "./WhySpotCancerEarly.vue?vue&type=template&id=ae018138&"
import script from "./WhySpotCancerEarly.vue?vue&type=script&lang=js&"
export * from "./WhySpotCancerEarly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports